<template>
	<app-layout title="UpgradeSuccess">
	  <template v-slot:sidenav> </template>
  
	  <template v-slot:horizonav>
		<nav-bar :scId="selectedId" :scType="selectedType"> </nav-bar>
	  </template>
    
	 <!-- card start -->
	<div class="h-screen my-5 w-full flex items-center justify-center dark:bg-gray-900">

<!-- Author card -->
		<div
			class="relative   m-5 md:my-4 flex flex-col items-start space-y-4 sm:flex-row sm:space-y-0 sm:space-x-6 p-5  rounded-lg " style="background-color: rgb(227, 227, 240); width: 80%;">

			<div class="w-full sm:w-auto  items-center sm:items-start">
		<h2
			class="
			font-bold
			tracking-wide
			font-sans
			text-blue-700"
			>
			Thank You!
        </h2>
      <p class=" text-gray-700 md:text-lg font-light">
        We have sucessfully deployed <strong> productName </strong> to
        <strong> tenantHostName </strong>.
      </p>

					<button class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded inline-flex items-center">
						<a v-bind:href="'https://'+tenantHostName+'/dashboard'" class="text-white no-underline">Go To Dashboard</a>
					&nbsp;
					<img :src="'/imgs/arw.png'" alt="" class="" loading="lazy"/>
					</button>
				
			</div>

		</div>

    </div>
	 <!-- card end -->
	</app-layout>
  </template>
  
  <script>
  import AppLayout from "@/Layouts/AppLayout.vue";
  import NavBar from "@/Layouts/NavBar.vue";
  
  export default {
	props: {
		productName: String,
    tenantHostName: String,
	},
	components: {
	  AppLayout,
	  NavBar,
	},
	data() {
	  return {
		mainUrl: null,
	  };
	},
  
	 methods: {
		gotoDashBoard(){
	inertia.get(this.mainUrl)
	},
	},
	mounted() {
        this.mainUrl = "https://"+this.tenantHostName+"/dashboard"
	},
  };
  </script>
  
  <style>
  </style>